module.exports = __webpack_public_path__ + "img/12.2fe136b8.png";